import { http } from '@/libs/util'
import util from '@/libs/util'
const { 
    expense_group_save,
    expense_group_detail,
    contract_detail,
    outsource_contract_detail,
    payee_company_account_select_search,
    expense_group_import_expense
 } = util.api || {}


 export function saveExpenseGroupSaveApi(params) {
    return http.post(expense_group_save, params)
}


export function getExpenseGroupDetailApi(params) {
    return http.get(expense_group_detail, params)
}

export function getContractDetailApi({id} = {}) {
    return http.get(contract_detail, {id})
}

// 获取简直外包合同
export function getOutsourceContractDetailApi(params) {
    return http.get(outsource_contract_detail, params)
}

// 获取收款账户
export function getPayeeApi(params) {
    return http.get(payee_company_account_select_search, params)
}


export function importDataApi(params) {
    return http.post_upload(expense_group_import_expense, params)
}